// Catálogo compartido de equipos usado por Operations.jsx y MyShiftDialog.jsx.
// Cada entrada define los campos que aplican a ese equipo:
//   metrics[]        — key/label/type triples renderizados por segmento
//   needsHelper      — mostrar dropdown de ayudante en el header
//   needsOrigin      — Origen / Destino / Distancia (movilidad)
//   needsFuel        — Diésel (lt)
//   needsHorometer   — Horómetro inicial/final
//   needsHorometerEP — Bolter/Jumbo: Eléctrico + Percusión
//   needsDelays      — Demora inicio / fin / motivo
//   servicesCatalog  — Servicios: tipo desde catálogo editable
import { Hammer, Truck, Fire, Wrench, Anchor } from "@phosphor-icons/react";

export const EQUIPMENT = [
  { v: "anclador", label: "Anclador (Bolter)", icon: Anchor, color: "bg-amber-50",
    needsHelper: true, needsHorometerEP: true, needsDelays: true,
    metrics: [
      { k: "pernos", l: "Anclas instaladas", type: "number" },
      { k: "malla_m2", l: "Malla instalada (m²)", type: "number" },
      { k: "bnos_dados", l: "Barrenos perforados", type: "number" },
      { k: "bnos_serv", l: "Barrenos de servicio", type: "number" },
      { k: "longitud_ancla_m", l: "Longitud ancla (m)", type: "number", step: "0.1" },
      { k: "tipo_ancla", l: "Tipo ancla (varilla / split-set / resina)", type: "text" },
      { k: "acero_barras_32mm", l: "Consumo acero barras 32 mm", type: "number" },
      { k: "acero_barras_35mm", l: "Consumo acero barras 35 mm", type: "number" },
      { k: "brocas_32mm", l: "Consumo brocas 32 mm", type: "number" },
      { k: "brocas_35mm", l: "Consumo brocas 35 mm", type: "number" },
    ],
  },
  { v: "jumbo", label: "Jumbo", icon: Hammer, color: "bg-blue-50",
    needsHelper: true, needsOrigin: true, needsFuel: true, needsHorometerEP: true, needsDelays: true,
    metrics: [
      { k: "metros", l: "Metros perforados", type: "number", step: "0.1" },
      { k: "barrenos", l: "Nº barrenos", type: "number" },
      { k: "encapille_m", l: "Encapille (m)", type: "number", step: "0.01" },
      { k: "desp_desb_m", l: "Despatille / Desbroce (m)", type: "number", step: "0.01" },
      { k: "acero_barras_16ft", l: "Barras 16 ft", type: "number" },
      { k: "ext_sondeo_6ft", l: "Extensiones sondeo 6 ft", type: "number" },
    ],
  },
  { v: "voladuras", label: "Voladuras", icon: Fire, color: "bg-red-50",
    needsHelper: true, needsDelays: true,
    metrics: [
      { k: "barrenos", l: "Nº barrenos disparados", type: "number" },
      { k: "avance_m", l: "Avance (m)", type: "number", step: "0.01" },
      { k: "seccion", l: "Sección de desarrollo (ej. 4x4)", type: "text", list: "dev-sections" },
      { k: "eficiencia_pct", l: "Eficiencia / Disponibilidad (%)", type: "number", step: "0.1" },
      { k: "encapille_m", l: "Encapille (m)", type: "number", step: "0.01" },
      { k: "exp_mexa_kg", l: "Mexa (kg)", type: "number", step: "0.1" },
      { k: "exp_bombillo_pz", l: "Bombillos (pz)", type: "number" },
      { k: "exp_canuela_m", l: "Cañuela (m)", type: "number", step: "0.1" },
      { k: "exp_lp_pz", l: "LP (pz)", type: "number" },
      { k: "exp_ms_pz", l: "MS (pz)", type: "number" },
      { k: "exp_cordon_m", l: "Cordón detonante (m)", type: "number", step: "0.1" },
    ],
  },
  { v: "scoop", label: "Scoop tram", icon: Truck, color: "bg-emerald-50",
    needsOrigin: true, needsFuel: true, needsHorometer: true, needsDelays: true,
    metrics: [
      { k: "toneladas", l: "Toneladas cargadas", type: "number", step: "0.1" },
      { k: "cucharones", l: "Cucharones (viajes)", type: "number" },
      { k: "ciclos", l: "Ciclos", type: "number" },
      { k: "km_recorridos", l: "Km recorridos (turno)", type: "number", step: "0.1" },
    ],
  },
  { v: "camion", label: "Camión bajo perfil", icon: Truck, color: "bg-slate-50",
    needsOrigin: true, needsFuel: true, needsHorometer: true, needsDelays: true,
    metrics: [
      { k: "toneladas", l: "Toneladas transportadas", type: "number", step: "0.1" },
      { k: "viajes", l: "Nº viajes", type: "number" },
      { k: "n_scoop_por_viaje", l: "Nº cucharones por viaje", type: "number", step: "0.1" },
      { k: "ciclos", l: "Ciclos", type: "number" },
      { k: "km_recorridos", l: "Km recorridos (turno)", type: "number", step: "0.1" },
    ],
  },
  { v: "servicios", label: "Servicios", icon: Wrench, color: "bg-purple-50",
    needsHelper: true, servicesCatalog: true,
    metrics: [
      { k: "metros_instalados", l: "Metros instalados", type: "number", step: "0.1" },
      { k: "actividad", l: "Tipo de trabajo / actividad", type: "text" },
    ],
  },
  { v: "telehandler", label: "Tele handler", icon: Truck, color: "bg-cyan-50",
    needsHorometer: true, needsFuel: true, needsDelays: true,
    metrics: [{ k: "actividad", l: "Actividad realizada", type: "text" }] },
  { v: "retro", label: "Retroexcavadora", icon: Wrench, color: "bg-orange-50",
    needsHorometer: true, needsFuel: true, needsDelays: true,
    metrics: [{ k: "actividad", l: "Actividad realizada", type: "text" }] },
  { v: "motoniv", label: "Motoniveladora", icon: Truck, color: "bg-lime-50",
    needsHorometer: true, needsFuel: true, needsDelays: true,
    metrics: [{ k: "actividad", l: "Actividad realizada", type: "text" }] },
];

export const SHIFT_LABEL = { dia: "Día", noche: "Noche" };

export const findEquipment = (type) => EQUIPMENT.find((e) => e.v === type) || null;
